export default "__VITE_ASSET__BD66D0jg__"